import React from 'react';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import LocalTexts from '../../../../HomepageTexts.json';
import useShowNewHomepage from '../../../../Hooks/useShowNewHomepage';

import styles from './HeroContent.scss';

const LocalT = new MDText(LocalTexts);
const t = (key: string, args?: Record<string, string | React.ReactNode>) => `${LocalT.translate(key, args)}`;

export const TEXTS = {
  headline: {
    static: {
      0: t('hero.headline.static.0'),
      1: t('hero.headline.static.1'),
    },
  },
  subTitle: LocalT.translate('hero.subTitle', {
    TnC: <sup className={styles.TnC}>*</sup>,
  }),
  title: t('hero.title'),
};

export const HeroContent = () => {
  const { showNewHomepage } = useShowNewHomepage();

  const homepageVRMDescription = (
    <div className={styles.heroSubTitleWrapper}>
      <p className={ styles.heroSubTitle } data-cy="homepageHeroVRM">
        { TEXTS.subTitle }
      </p>
    </div>
  );

  return (
    <>
      <h1
        className={cx(styles.heroTitleStatic, {
          [styles.nextHomepage]: showNewHomepage,
        })} >
        {TEXTS.headline.static[0]}
        <br />
        {TEXTS.headline.static[1]}
      </h1>
      {homepageVRMDescription}
    </>
  );
};
